export default {
  RoleList: {
    Title: 'Vai trò quyền hạn',
    EditChooseUser: 'Sửa và chọn người dùng',
    SetRole: 'Thiết lập quyền hạn',
  },
  RoleDetail: {
    RoleCode: 'Mã hiệu *',
    RoleCodeTitle: 'Mã vai trò *',
    RoleName: 'Tên vai trò *',
    Description: 'Diễn giải',
    ChooseUser: 'Chọn người dùng',
  },
  SetRolePopup: {
    Title: 'Thiết lập quyền hạn',
    MajorTab: 'Nghiệp vụ',
    ReportTab: 'Báo cáo',
    CheckAll: 'Chọn/ Bỏ chọn tất cả',
    ZoomIn: 'Thu gọn',
    ZoomOut: 'Mở rộng',
    Use: 'Sử dụng',
    ReportName: 'Báo cáo ngân sách xã',
  },
};
